module.exports = __webpack_public_path__ + "static/img/ud_device_bgk1.f72a9b8d.png";